import React from 'react';
import {Grid, Header, Container, Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

const TopRewardsPanel = props => (
  <div className='top-rewards'>
    <Header as='h2'>
      <FormattedMessage id='rewardsStore.dashboard.topRewards.header' values={{site: props.site}} />
    </Header>
    <Grid>
      {props.topRewards.map(reward => (
        <Grid.Row columns={2} key={reward.id}>
          <Grid.Column width={11}>
            {reward.title}
          </Grid.Column>
          <Grid.Column width={1}>
            {reward.total}
          </Grid.Column>
        </Grid.Row>
      ))}
    </Grid>
  </div>
);

export default TopRewardsPanel;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsDashboard/TopRewardsPanel.jsx